import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/docs",
      name: "docs",
      component: () => import("./views/Docs.vue")
    },
    {
      path: "/how-it-works",
      name: "how it works",
      component: () => import("./views/HowItWorks.vue")
    },
    {
      path: "/pricing",
      name: "pricing",
      component: () => import("./views/Pricing.vue")
    },
    {
      path: "/contact",
      name: "contact",
      component: () => import("./views/Contact.vue")
    },
    {
      path: "/patents",
      name: "patents",
      component: () => import("./views/Patents.vue")
    },
    {
      path: "/terms-of-use",
      name: "terms",
      component: () => import("./views/Terms.vue")
    },
    {
      path: "/privacy",
      name: "privacy",
      component: () => import("./views/Privacy.vue")
    },
    {
      path: "/community-guidelines",
      name: "community guidelines",
      component: () => import("./views/CommunityGuidelines.vue")
    },
    {
      path: "*",
      component: () => import("./views/PageNotFound.vue")
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});
